/**
 * Used on public routes to load the tileset metadata.
 *
 * NOTE: don't use this function unless you specifically need to load the
 * tileset metadata for non-authed users. For authed users, use the GraphQL
 * TilesetsQuery.
 */
export const loadTilesetsMetadata = async () => {
  const response = await fetch('/api/public/tileset_metadata');

  if (response.status !== 200) {
    const responseText = await response.text();
    throw new Error(responseText);
  }

  const json = await response.json();
  const { results, error } = json;

  if (!results || error) {
    throw new Error(error ?? 'Failed to fetch tilesets metadata');
  }

  return results;
};
